module.exports = "<a class=\"kl-gotop kl-gotop--{position} {class}\" r-hide={!visible} on-click={this.gotop()}>\n    {#if this.$body}\n        {#inc this.$body}\n    {#else}\n        <kl-icon type={arrow-up} />\n    {/if}\n</a>\n"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/_deprecated_/gotop/index.html
// module id = 376
// module chunks = 0